<template>
  <main class="sa-content">
    <div class="sa-card-large">
      <div class="sa-mob-header">
        <h5 class="sa-card-tit">Sick Leave</h5>
        <button class="sa-btn-back" @click="$router.push('/appointments/doctor-details/add-diagnosis/'+$route.params.appid)">
            <i class="icon-arrow-left"></i>
          </button>
      </div>
      <sick-leave />
    </div>
  </main>
</template>
<script>
import SickLeaveVue from '../../../../components/appointments/diagnosis/sick-leave/SickLeave.vue';
export default {
  components: {
    'sick-leave': SickLeaveVue
  },
  data() {
    return {
      
    };
  },
  
  
  methods: {
    
  }
};
</script>
